import { HttpClient } from "@angular/common/http"
import { Inject, Injectable } from "@angular/core"
import { context, trace } from "@opentelemetry/api"
import { GRAYLOG_URI } from "./const/graylogConstants"
import { IGraylog } from "./interface/IGraylog"
import {
  STRING_LEVEL_ERROR,
  HOST,
} from "src/app/cadastro/admin/services/graylog/const/graylogConstants"
import { environment } from "src/environments/environment"

@Injectable({
  providedIn: "root",
})
export class GrayLogService {
  constructor(
    private httpClient: HttpClient,
    @Inject(GRAYLOG_URI) private grayLogURI: string
  ) {}

  logError(full_message: string) {
    // Correlates GrayLog entries with the OTEL trace active at the time of the error, if any.
    const spanContext = trace.getSpan(context.active())?.spanContext()

    let body: IGraylog = {
      full_message: full_message,
      host: HOST.toString(),
      short_message: "error in hub-front-end",
      environment: environment.name,
      stringLevel: STRING_LEVEL_ERROR.toString(),
      level: "1",
      facility: "Node.js",
      version: "1.1",
      trace_id: spanContext?.traceId,
      span_id: spanContext?.spanId,
    }

    const ob = JSON.stringify(body)

    return this.httpClient.post(this.grayLogURI, ob).subscribe((res) => res)
  }
}
